import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/language.service';
import { careers } from 'src/app/model/careers';
import { EngineeeringService } from 'src/app/engineeering.service';
import { FormBuilder, Validators } from '@angular/forms';


declare var grecaptcha: any;

@Component({
  selector: 'app-careers-it',
  templateUrl: './careers-it.component.html',
  styleUrls: ['../../pages/careers/careers.component.css']
})
export class CareersItComponent implements OnInit {
  siteKeyCaptcha: string = "6Lds-u4UAAAAAJgKvQsuHvjsDUCyO7g5AXDacvcu";
  model:careers;

  sendMail: boolean = false;
  captcha: boolean = false;

  fileName:string = '';
  file:any;
  careersForm =   this.fb.group({
    name: ['', Validators.required],
    surname: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    phone: [''],
    company: [''],
    jobRole:[''],
    message: [''],
    auth: ['', Validators.required],
    captcha: ['', Validators.required],
    file: ['', Validators.required]
  });

  constructor(public languageService: LanguageService,
     private service:EngineeeringService,
    private fb:FormBuilder
    ) { }

  ngOnInit() {
    grecaptcha.render('capcha_element', {
      'sitekey': this.siteKeyCaptcha
    });
    window['getResponceCapcha'] = this.getResponceCapcha.bind(this);
  }

  getResponceCapcha(captchaResponse: string) {
    this.verifyCaptcha(captchaResponse);
  }
  
  verifyCaptcha(captchaResponse: string) {
    this.careersForm.patchValue({ captcha: true });
  }

  fake() {
    this.careersForm.patchValue({ captcha: true });
  }

  fileChange(event): void {
    console.log(event);

    const fileList: FileList = event.target.files;

    if (fileList.length > 0) {
      const f = fileList[0];
      this.file = f;
      this.fileName = f.name;
      this.careersForm.patchValue({ file: true });
    }
  }
  async onSubmit() {
    this.model = new careers(this.careersForm.value)
    this.model.curriculum = this.file;
    await this.service.sendMailCareers(this.model).subscribe();
    location.reload();
  }
}
